module.exports = __webpack_public_path__ + "static/gtm_6-ed07ef2ed86772333cb56b1505c5fff5.png";